import React, { Component } from 'react'
import ConfigService from '../../../services/configuracion/ConfigService';
import Titulo from "../../generico/TituloPagina";
import ItemSucursal from './ItemSucursal';
import Mapa from './Mapa';

const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3
};

var mapaRef;
var itemRef;

export default class SucursalesCercanas extends Component {

    constructor(props) {
        super(props);
        this.moverMapa = this.handleMoveCamera.bind(this);
        this.obtenerPosicionActual = this.obtenerPosicionActual.bind(this);

        mapaRef = React.createRef();
        itemRef = React.createRef();

        this.state = {
            cargandoSucursales: true,
            sucursales: [],
            posicionActual: [-25.293056307693337, -57.57617997244167],
            settings: settings
        }

    }

    componentDidMount() {
        this.obtenerPosicionActual();
    }

    obtenerPosicionActual() {

        const location = "geolocation" in navigator;

        if (location) {

            navigator.geolocation.getCurrentPosition((position) => {

                let posicionActual = [position.coords.latitude, position.coords.longitude];

                this.setState({
                    ...this.state,
                    posicionActual: posicionActual,
                    //cargandoSucursales: true
                });

                this.listarSucursalesCercanas(posicionActual);

            }, (error) => {
                //si la ubicacion no esta habilitada
                if (error.code === 1) {
                    this.listarSucursalesCercanas(this.state.posicionActual);
                }
            });

        } else {

            this.listarSucursalesCercanas(this.state.posicionActual);

        }

    }

    listarSucursalesCercanas(localizacion) {
        ConfigService.obtenerSucursalesCercanas(localizacion)
            .then((response) => {

                let listSuc = response.data.datos;

                this.setState({
                    ...this.state,
                    cargandoSucursales: false,
                    sucursales: listSuc
                });

            })
            .catch(error => {
                console.log(error);
            })
    }

    handleMoveCamera(coordenadas, zoom) {
        mapaRef.moverCamara(coordenadas, zoom);
        mapaRef.activarPopup({ latitud: parseFloat(coordenadas[0]), longitud: parseFloat(coordenadas[1]) });
    }

    handleClickPopup(sucursal) {
        itemRef.selectCardSucursal(sucursal.nombreSucursal);
    }

    render() {
        return (
            <div className="content-wrapper">
                <Titulo texto="Sucursales Cercanas" />
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12 col-md-4 order-2 order-md-1 mb-3">
                            <div id='sucursalList' className="list-group sucursal-list" >
                                {
                                    this.state.cargandoSucursales
                                        ? null
                                        :
                                        this.state?.sucursales.map((sucursal, index) => {
                                            return (
                                                <ItemSucursal
                                                    ref={element => { itemRef = element }}
                                                    key={index}
                                                    sucursal={sucursal}
                                                    ubicacionActual={this.state.posicionActual}
                                                    clickCard={this.handleMoveCamera}
                                                />
                                            )
                                        })
                                }
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-8 order-1 order-md-2 mb-3">
                            {
                                this.state.cargandoSucursales
                                    ? null
                                    : <Mapa
                                        ref={element => { mapaRef = element }}
                                        sucursales={this.state.sucursales}
                                        posicionActual={this.state.posicionActual}
                                        actualizarPosicion={this.obtenerPosicionActual}
                                        clickPopup={this.handleClickPopup}
                                    />
                            }
                        </div>
                    </div>
                    {/* <div className="row d-none">
                        <div className="col-md-12 mt-2">
                            <Slider {...this.state.settings}>
                                {
                                    this.state?.sucursales.map((sucursal, index) => {
                                        return (
                                            <CardSucursal
                                                key={index}
                                                nombre={sucursal.nombreSucursal}
                                                distancia={sucursal.distancia}
                                                coordenadas={[sucursal.latitud, sucursal.longitud]}
                                                clickCard={this.handleMoveCamera}
                                            />
                                        )
                                    })
                                }
                            </Slider>
                        </div>
                    </div> */}
                </div>
            </div >
        )
    }

}